export default __webpack_public_path__ + "static/media/more-horizontal.65c7fd6f.svg";